import { loader } from "graphql.macro";

const typeDefs = loader("../graphqlBase/client/clientSchema.graphql");

export default typeDefs;
